import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'

import echarts from "echarts";
Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false;
// Vue.prototype.clientUrl = "//192.168.50.187:8100";
// Vue.prototype.clientUrl = "//client.text.gogotranx.com";
// Vue.prototype.clientUrl = process.env.NODE_ENV === 'development' ? "https://client.cs.gogotranx.com" : 'https://client.gogotranx.com';
Vue.prototype.clientUrl = "https://client.glacix.com";
Vue.prototype.backendUrl = "http://api.glacix.com";

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
